export const serviceData = {
    "ocean-freight-shipping": [
        {
            path: 'Ocean Freight Shipping',
            icon: 'directions_boat',
            name: 'Ocean Freight',
            sname: 'Ocean Freight,',
            snamehighlightes: 'handled',
            mobdesc: 'FCL & LCL ocean shipping.',
            description: "Most of your cargo moves by sea — so we make ocean freight the part you never have to think about. Full-container or shared, we book direct with carriers, watch every box by GPS, and turn your documents around the same day.",
            features: [
                { icon: 'directions_boat', text: 'FCL & LCL — full or shared containers, priced honestly' },
                { icon: 'schedule', text: 'Carrier-direct booking across the major ocean lines' },
                { icon: 'receipt_long', text: 'Live GPS container tracking from port to port' },
                { icon: 'shield', text: 'Bills of lading and shipping documents handled same-day' }
            ],
            heroStats: [
                { value: '200+', label: 'Carriers covered' },
                { value: '24h', label: 'Doc turnaround' },
                { value: '98%', label: 'On-time rate' }
            ],
            steps: [
                { num: '1', title: 'Get your rate', desc: 'An instant estimate on screen — then a specialist sanity-checks it.' },
                { num: '2', title: 'Book & ship', desc: 'We confirm space, arrange pickup, and file your paperwork.' },
                { num: '3', title: 'Track to the door', desc: 'Follow every milestone until your cargo is delivered.' }
            ],
            agentName: 'Kesh',
            agentTitle: 'Dedicated Ocean Freight Specialist',
            crossLinks: [
                { name: 'Customs Clearance', route: 'services/custom-clearance-services' },
                { name: 'ISF Filing', route: 'services/importer-security-filing' },
                { name: 'Cargo Insurance', route: 'services/freight-cargo-insurance' },
                { name: 'Air Freight', route: 'services/air-freight' },
                { name: 'Trucking & Warehousing', route: 'services/trucking-and-warehousing' }
            ]
        }
    ],
    "air-freight": [
        {
            path: 'Air Freight Services',
            icon: 'travel',
            name: 'Air Freight',
            sname: 'Air freight,',
            snamehighlightes: 'handled',
            description: "When sea is too slow, air gets it there. We move time-sensitive cargo from India to the USA with fast customs clearance and last-mile delivery built in — so a tight deadline stays a deadline you can keep.",
            features: [
                { icon: 'flight_takeoff', text: 'Express and standard air options, India to USA',desc:'Same-day quoting on both express and deferred rates — you choose the speed, we lock the price and confirm the space.' },
                { icon: 'speed', text: 'Priority customs clearance on arrival',desc:'Our licensed US customs broker files entry before the flight lands so your cargo clears the same day it touches down.' },
                { icon: 'security', text: 'Last-mile delivery to the final address',desc:`We don't stop at the airport. Drayage and final delivery to any so your cargo clears the same day it touches down.` },
                { icon: 'local_shipping', text: 'Proactive updates at every handoff',desc:`Departed, airborne, landed, cleared, out for delivery — you get a notification at each step without having to ask.` }
            ],
            heroStats: [
                { value: '200+', label: 'Air shipments moved' },
                { value: '97%', label: 'On-time delivery' },
                { value: '50+', label: 'Airline partners' },
                { value: '48h', label: 'Avg. India–USA transit' }
            ],
              routeQuickStats: [
                { value: '24 - 48 hrs', label: 'Express transit'},
                { value: '3 - 5 days', label: 'Standard transit'},
                { value: 'MAA, BOM, DEL', label: 'origin airports'},
                { value: 'LAX, JFK, ORD, IAD', label: 'Dest. airports'},
                { value: '97%', label: 'On-time rate'},
            ],
            steps: [
                { num: '1', title: 'Send your details', desc: 'Tell us the cargo, weight and the deadline it has to hit.' },
                { num: '2', title: 'We book the space', desc: 'Flights confirmed, customs prepped, pickup arranged.' },
                { num: '3', title: 'It lands on time', desc: 'Cleared on arrival and delivered to the final address.' }
            ],
            agentName: 'Dave',
            agentTitle: 'Dedicated Air Logistics Specialist',
            crossLinks: [
                { name: 'Customs Clearance', route: 'services/custom-clearance-services' },
                { name: 'Cargo Insurance', route: 'services/freight-cargo-insurance' },
                { name: 'ISF Filing', route: 'services/importer-security-filing' },
                { name: 'Ocean Freight', route: 'services/ocean-freight-shipping' },
                { name: 'Trucking & Warehousing', route: 'services/trucking-and-warehousing' }
            ]
        }
    ],
    "trucking-and-warehousing": [
        {
            path: 'Trucking & Warehousing Services',
            icon: 'description',
            name: 'Trucking & Warehousing',
            sname: 'Trucking & Warehousing',
            description: "The last leg is where shipments quietly go wrong. We handle drayage and trucking from port or rail straight to your warehouse, with storage when timing does not line up — keeping cargo on schedule and off the demurrage clock",
            features: [
                { icon: 'warehouse', text: 'Drayage from the port or rail terminal',desc:`We pick up your container the moment it releases — same-day drayage from LA/Long Beach, Houston, and major rail ramps — so you never pay a day of demurrage you didn't have to.` },
                { icon: 'local_shipping', text: 'FTL and LTL trucking to your door',desc: `Full truckloads or shared loads — we match your cargo volume  to the right move and quote both options when it's close, so you always get the better price.` },
                { icon: 'precision_manufacturing', text: 'Short- and long-term warehousing',desc: `Secure, climate-controlled space at our Westlake Village facility — for a few days between modes or months of bonded storage while you distribute.` },
                { icon: 'fmd_good', text: 'Schedule coordination to avoid demurrage & detention',desc: `We track your container's free-time window and schedule pickup and return proactively — your carrier charges stay predictable.` }
            ],
            heroStats: [
                { value: '7,900+', label: 'Loads delivered' },
                { value: '99%', label: 'Damage-free rate' },
                { value: '2', label: 'US warehouse locations' },
                { value: '$0', label: 'Demurrage incidents' }
            ],
              routeQuickStats: [
                { value: 'LA / LB / Houston', label: 'Same-day drayage'},
                { value: '48 contiguous states', label: 'Trucking coverage'},
                { value: 'Westlake Village, CA', label: 'Warehouse'},
                { value: 'Short- & long-term', label: 'Storage options'},
                { value: '99%', label: 'Damage-free rate'},
            ],
            steps: [
                { num: '1', title: 'Share the shipment', desc: 'Container or LCL, port of arrival, delivery address.' },
                { num: '2', title: 'We schedule the move', desc: 'Drayage and trucking booked around your timing.' },
                { num: '3', title: 'Delivered or stored', desc: 'To your door — or into our warehouse until you need it.' }
            ],
            agentName: 'Jim',
            agentTitle: 'Distribution & Fulfillment Director',
            crossLinks: [
                { name: 'Ocean Freight', route: 'services/ocean-freight-shipping' },
                { name: 'Customs Clearance', route: 'services/custom-clearance-services' },
                { name: 'Cargo Insurance', route: 'services/freight-cargo-insurance' },
                { name: 'Air Freight', route: 'services/air-freight' },
                { name: 'ISF Filing', route: 'services/importer-security-filing' }
            ]
        }
    ],
    "importer-security-filing": [
        {
            path: 'Importer Security Filing',
            icon: 'description',
            name: 'ISF Filing',
            sname: 'ISF Filing.',
            description: "Your ISF has to reach US Customs before your cargo sails — and a late or wrong filing means a $5,000 penalty. We file it for you as agent for the Importer of Record, accurately and on time, so that worry simply disappears from your list.",
            features: [
                { icon: 'gavel', text: 'ISF 10+2 filed directly into the US Customs system',desc: `We transmit all 10 importer elements and 2 carrier elements electronically via ACE  — no paper, no intermediaries, no gaps that invite a $5,000 fine.` },
                { icon: 'verified_user', text: 'Filed as agent for the Importer of Record',desc: `We act as your authorised filing agent — meaning we carry the responsibility end-to-end and you stay fully compliant without lifting a finger.` },
                { icon: 'bolt', text: 'Submitted before the carrier cutoff — every time',desc:`CBP requires the ISF at least 24 hours before sailing. We track every cutoff window and file well ahead of it — so a last-minute schedule change never catches you out.` },
                { icon: 'update', text: 'Data checked against your commercial documents',desc:`Before we file, we cross-reference your invoice, packing list, and booking confirmation so discrepancies are caught internally — not flagged by CBP.` }
            ],
            heroStats: [
                { value: '6,400+', label: 'ISF filings completed' },
                { value: '$0', label: 'Penalties incurred' },
                { value: '100%', label: 'Filed before cutoff' },
                { value: '24h', label: 'Avg. turnaround' }
            ],
              routeQuickStats: [
                { value: '24 hrs before sailing', label: 'CBP requirement'},
                { value: 'Up to $5,000', label: 'Late filing penalty'},
                { value: 'ACE / AMS direct', label: 'Filing method'},
                { value: 'Within 24 hrs of docs', label: 'Turnaround'},
                { value: '$0 incurred', label: 'Penalty record'},
            ],
            steps: [
                { num: '1', title: 'Send your documents', desc: 'Commercial invoice, packing list and booking details.' },
                { num: '2', title: 'We file the ISF', desc: 'Submitted to US Customs ahead of the carrier cutoff.' },
                { num: '3', title: 'You get confirmation', desc: 'Filing reference on record — no penalties, no stress.' }
            ],
            agentName: 'Mark',
            agentTitle: 'Compliance Officer',
            crossLinks: [
                { name: 'Ocean Freight', route: 'services/ocean-freight-shipping' },
                { name: 'Customs Clearance', route: 'services/custom-clearance-services' },
                { name: 'Cargo Insurance', route: 'services/freight-cargo-insurance' },
                { name: 'Air Freight', route: 'services/air-freight' },
                { name: 'Trucking & Warehousing', route: 'services/trucking-and-warehousing' }
            ]
        }
    ],
    "custom-clearance-services": [
        {
            path: 'Customs Clearance Services',
            icon: 'description',
            name: 'Customs Clearance',
            sname: 'Customs Clearance.',
            description: "Cargo sitting at the port costs you money every day. Our experienced customs agents prepare and file your entry, classify goods correctly, and clear release quickly — so your shipment keeps moving and you stay on the right side of CBP.",
            features: [
                { icon: 'assignment', text: 'Entry preparation and filing with CBP',desc:`Our licensed customs brokers prepare and transmit your formal entry — ocean, air, or truck — directly into ACE, with every field verified before submission so nothing bounces back.` },
                { icon: 'account_balance', text: 'Accurate HTS classification and duty calculation',desc:`We classify your goods to the correct 10-digit HTS code, calculate applicable duties and fees upfront, and flag any Section 301 tariff exposure before the entry is filed — no surprise bills at clearance.` },
                { icon: 'engineering', text: 'Coordination with the port and your carrier',desc:`We liaise directly with the terminal, port authority, and your ocean or air carrier so release instructions are issued the moment CBP clears your cargo — no delays between approval and pickup.` },
                { icon: 'task_alt', text: 'Guidance on tariffs, exclusions and documentation',desc: `We review your commercial documents for accuracy and completeness, identify applicable duty exclusions or drawback opportunities, and advise on compliance before your next shipment — not after a problem surfaces.` }
            ],
            heroStats: [
                { value: '9,400+', label: 'Entries filed' },
                { value: '99%', label: 'First-pass release rate' },
                { value: '$0', label: 'CBP penalty record' },
                { value: 'Same day', label: 'Release on arrival' }
            ],
            routeQuickStats: [
                { value: '9,400+', label: 'Entries filed'},
                { value: '99%', label: 'First-pass release'},
                { value: 'Ocean, air, truck', label: 'Modes covered'},
                { value: 'LA, LB, JFK, IAD, ORD', label: 'Ports covered'},
                { value: '$0', label: 'CBP penalty record'},
            ],
            steps: [
                { num: '1', title: 'We receive your docs', desc: 'Entry paperwork and classification prepared in advance.' },
                { num: '2', title: 'Entry filed with CBP', desc: 'Duties calculated, exclusions applied where they fit.' },
                { num: '3', title: 'Cargo released', desc: 'Cleared quickly so your shipment keeps moving.' }
            ],
            agentName: 'Mark',
            agentTitle: 'Lead Customs Brokerage Specialist',
            crossLinks: [
                { name: 'Ocean Freight', route: 'services/ocean-freight-shipping' },
                { name: 'ISF Filing', route: 'services/importer-security-filing' },
                { name: 'Trucking & Warehousing', route: 'services/trucking-and-warehousing' },
                { name: 'Air Freight', route: 'services/air-freight' },
                { name: 'Cargo Insurance', route: 'services/freight-cargo-insurance' }
            ]
        }
    ],
    "freight-cargo-insurance": [
        {
            path: 'Freight Cargo Insurance',
            name: 'Cargo Insurance',
            sname: 'Cargo Insurance.',
            icon: 'description',
            description: "Ocean and air carriers limit their liability to a fraction of your cargo value. We arrange all-risk cargo insurance through trusted providers right when you book — so if something goes wrong in transit, you are made whole, not left arguing",
            features: [
                { icon: 'star', text: 'PreAll-risk coverage through trusted insurers',desc:`We place cover with A-rated marine insurers — all-risk clauses not the named-perils policies carriers slip into the fine print. Your cargo is protected against physical loss or damage from any external cause.` },
                { icon: 'umbrella', text: 'Arranged at the time of booking — no scramble later',desc:`Coverage is confirmed when your freight booking is confirmed — not an afterthought when something goes wrong. The certificate of insurance is ready before the cargo leaves origin.` },
                { icon: 'quickreply', text: 'Covers the ocean, air and inland legs',desc:`A single policy follows your cargo door to door — ocean voyage, transshipment, drayage, and final-mile delivery are all covered under the same certificate, no coverage gaps between modes.` },
                { icon: 'add_card', text: 'Straightforward claims support if you ever need it',desc:`If a claim arises, we manage it — documentation, surveyor coordination, insurer liaison. You are not handed a phone number and left to argue. We stay involved until the claim is settled.` }
            ],
            heroStats: [
                { value: '8,100+', label: 'Policies arranged' },
                { value: '100%', label: 'Claims supported' },
                { value: 'All-risk', label: 'Coverage standard' },
                { value: 'At', label: 'booking — not after' }
            ],
            routeQuickStats: [
                { value: 'All-risk (ICC-A)', label: 'Coverage type'},
                { value: 'Ocean, air, inland', label: 'Modes covered'},
                { value: 'At time of booking', label: 'Arranged'},
                { value: 'A-rated providers', label: 'Insurer rating'},
                { value: '100% end-to-end', label: 'CBP penalty record'},
            ],
            steps: [
                { num: '1', title: 'Tell us the value', desc: 'Cargo value and route, declared at the time of booking.' },
                { num: '2', title: 'Coverage arranged', desc: 'An all-risk policy placed through a trusted insurer.' },
                { num: '3', title: 'Covered door to door', desc: 'And real claims support if you ever need to use it.' }
            ],
            agentName: 'Kesh',
            agentTitle: 'Risk Mitigation Specialist',
            crossLinks: [
                { name: 'Ocean Freight', route: 'services/ocean-freight-shipping' },
                { name: 'Air Freight', route: 'services/air-freight' },
                { name: 'Customs Clearance', route: 'services/custom-clearance-services' },
                { name: 'ISF Filing', route: 'services/importer-security-filing' },
                { name: 'Trucking & Warehousing', route: 'services/trucking-and-warehousing' }
            ]
        }
    ]
};

export const divCon = [
    {
        width: '10px',
        img: 'https://storage.googleapis.com/airlift-images/atmavaan_images/Tools/Web/Mask_Group_90.svg',
        mobiconUrl: 'https://storage.googleapis.com/airlift-images/atmavaan_images/Tools/Web/Mask_Group_89.svg',
        name: 'Rates',
        routeName: 'ocean-freight-rates',
        alt: 'Dollar Icon'
    },
    {
        width: '16px',
        img: 'https://storage.googleapis.com/airlift-images/atmavaan_images/Tools/Web/boat-outline-2.svg',
        mobiconUrl: 'https://storage.googleapis.com/airlift-images/atmavaan_images/Tools/Web/boat-outline-1.svg',
        name: 'Vessel Schedule',
        routeName: 'vessel-schedules',
        alt: 'Boat Icon'
    },
    {
        width: '16px',
        img: 'https://storage.googleapis.com/airlift-images/atmavaan_images/Home/Web/web_container_button.svg',
        mobiconUrl: 'https://storage.googleapis.com/airlift-images/atmavaan_images/Home/Web/Container_Tracking_Active.svg',
        name: 'Container Tracking',
        routeName: 'tracking-container',
        alt: 'Container Icon'
    }
];

export const titleChangemetaData = {
    'ocean-freight-shipping': {
        title: 'Ocean Freight Shipping: FCL & LCL from an NVOCC | Atmavaan',
        description: 'Ship FCL and LCL ocean freight with Atmavaan, an NVOCC. Compare rates online, book space and track every container through to delivery.'
    },
    'air-freight': {
        title: 'Fast Air Freight Services | Global Express Logistics',
        description: 'Reliable air freight services with expedited customs tracking and last-mile execution paths.'
    },
    'trucking-and-warehousing': {
        title: 'Integrated Warehousing & Freight Drayage Services',
        description: 'Keep supply chains fluid using precision warehousing nodes linked with top tracking networks.'
    },
    'importer-security-filing': {
        title: 'ISF 10+2 Filing (Importer Security Filing) | Atmavaan',
        description: 'Ensure compliance with Importer Security Filing (ISF 10+2) regulations. Get accurate, timely filings to avoid penalties and streamline your import process.'
    },
    'custom-clearance-services': {
        title: 'US Customs Clearance Services for Importers | Atmavaan',
        description: 'Customs clearance for ocean freight imports: entry paperwork prepared in advance, entry filed with CBP, duties calculated and cargo released.'
    },
    'freight-cargo-insurance': {
        title: 'Cargo Insurance for Ocean Freight: All-Risk Cover | Atmavaan',
        description: 'All-risk cargo insurance for ocean freight, arranged at booking through a trusted insurer, with door-to-door cover and claims support.'
    }
};